// @ts-nocheck
import {Column} from 'react-table'
import {UserCustomHeader} from '../apps/user-management/users-list/table/columns/UserCustomHeader'
import {MovementRecord} from './api'

const getMovementColumns = (): ReadonlyArray<Column<MovementRecord>> => [
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Warehouse'
        className='min-w-150px ps-4 text-center'
      />
    ),
    id: 'warehouseName',
    accessor: 'warehouseName',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Product'
        className='min-w-150px ps-4 text-center'
      />
    ),
    id: 'productName',
    accessor: 'productName',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='SKU Code' className='min-w-100px text-center' />
    ),
    accessor: 'skuCode',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Opening Stock'
        className='min-w-125px text-center'
      />
    ),
    accessor: 'openingStock',
    sortType: 'basic',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Stock In' className='min-w-125px text-center' />
    ),
    accessor: 'stockIn',
    sortType: 'basic',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Stock Out' className='min-w-100px text-center' />
    ),
    accessor: 'stockOut',
    sortType: 'basic',
    Cell: ({...props}) => (
      <span className='text-danger fw-bold'>{props.data[props.row.index].stockOut}</span>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Closing Stock' className='min-w-100px text-center' />
    ),
    accessor: 'closingStock',
    sortType: 'basic',
    Cell: ({...props}) => (
      <span className='text-primary fw-bold'>{props.data[props.row.index].closingStock}</span>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='UOM' className='min-w-70px text-center' />
    ),
    accessor: 'unit',
    sortType: 'string',
    Cell: ({...props}) => (
      <span className='badge badge-light-dark fw-bold'>{props.data[props.row.index].unit}</span>
    ),
  },
]

export {getMovementColumns}
